/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function HandFlower(props): JSX.Element {
  return (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <title>Hand with flower</title>
      <path
        d='M9 33.875C9.77545 33.5833 12.2569 33 15.9791 33C20.6318 33 24.8192 35.1875 27.1456 35.1875C29.0067 35.1875 29.7821 35.1875 29.9372 35.1875C30.8678 35.1875 32.7288 35.625 32.7288 37.375C32.7288 39.5625 31.333 40 29.9372 40C28.8206 40 26.06 40 24.8192 40H30.8678L43.8954 36.5C44.5157 36.3542 45.9425 36.325 46.687 37.375C47.6175 38.6875 46.2217 39.5625 45.7564 40C45.2912 40.4375 36.9163 47 30.8678 47C26.0289 47 14.2731 44.9583 9 43.9375'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect x='3' y='32' width='6' height='13' rx='2' stroke='#FF3E51' strokeWidth='2' />
      <path
        d='M26.4995 35C26.0526 31.4102 26.059 26.4232 27.719 21.8552'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.5229 20.5C11.5229 18.1 10.8563 10.8333 11.0229 7.5C13.0234 12 16.0225 9.5 20.5225 12.5C24.1225 14.9 24.0225 19.1667 23.5225 21C22.5226 21.8333 19.5229 22.9 15.5229 20.5Z'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.0225 16C35.4225 22.4 30.3558 22.6667 28.0225 22C26.6891 20.3333 24.8225 15.9 28.0225 11.5C31.2225 7.1 36.6891 4.66667 39.0225 4C39.0225 5.33333 38.6225 9.6 37.0225 16Z'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.0225 19.5C23.3558 20.5 26.1225 22.9 26.5225 24.5'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
